import {XauditModel} from '../xaudit.model';

export class AppointmentFlagDataModel extends XauditModel {
  AppointmentFlagID: string;
  AppointmentId: string;
  enumAppoitmentFlagID: string;
}
